// windowContentLoader.js
import { WALLPAPERS } from "./wallpapers.js";
export class windowContentLoader {
  constructor() {
    this.element = document.querySelector(".window-content");
    this.title = document.querySelector(".window-top .title");
    this.pathLabel = document.querySelector(".window-shell .path");
    this.countLabel = document.querySelector(".window-shell .count");
    this.wallpaper = document.querySelector(".wallpaper");
    this.window = document.querySelector("#mainWindow");
  }

  // `label` is what the window calls the buffer, which is not always what it
  // fetched: the bio is authored as README.html so an editor treats it as HTML,
  // and shown as README.txt because that is the joke.
  async loadContent(path, label = path) {
    try {
      const response = await fetch(path);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();

      this.element.innerHTML = html;
      // The title is rendered from this: VimMode appends [+] to it.
      this.title.dataset.buffer = label;
      this.title.textContent = `■ ${label}`;
      this.pathLabel.textContent = `"home.hal9.xyz/${label}"`;
      this.countLabel.textContent = this.describe(html);
      this.wallpaper.textContent = WALLPAPERS[label] ?? "";

      // Opening a buffer brings the window back, which is the only way back
      // from `:q!` short of a reload.
      this.window?.classList.remove("is-closed");
    } catch (error) {
      //console.error('Error loading content:', error);
    }
  }

  // What vim prints when it opens a file. Measured from the body we were
  // handed rather than read off Content-Length: nginx gzips HTML, and a gzipped
  // response carries no Content-Length at all — which is why this line used to
  // say "nullB" in a browser while the tests, with their mocked header, passed.
  describe(html) {
    const lines = html.split("\n").length;
    const bytes = new TextEncoder().encode(html).length;
    return `${lines}L, ${bytes}B`;
  }
}
